// extracted by mini-css-extract-plugin
export default {"tableCell":"SortableTableCell_tableCell__0z9GW","iconButtonContainer":"SortableTableCell_iconButtonContainer__bEgOs","tableCellContent":"SortableTableCell_tableCellContent__hWOQY"};